export class RequestReviewWidgetSettings {
  public reviewGoogle: string;
  public reviewFacebook: string;
  public reviewYelp: string;
  public reviewNextdoor: string;
  public reviewLandingPage: string;
}
